import { useQuery } from "react-query";
import { getScorecardArea } from "../../../../actions/CarrierAgreementMgmt/ScoreCard";


export const useScorecardArea = () => {
    const { data, isLoading, refetch } = useQuery(
        "GetScorecardArea",
        getScorecardArea,
        {
            refetchOnWindowFocus: false,
        }
    );

    return { data, isLoading, refetch };
};